<template>
  <div class="p-3 w-100 d-flex flex-column flex-md-row align-items-center justify-content-center ">
    <h6 class="m-0 p-0 font-weight-bold">
      {{ title }}
    </h6>
    <slot name="complement" />
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
    },
  }
</script>
